import Routes from '~/routes';

import './index.css'

const App = () => <Routes />;

export default App;
